<template>
  <div class="messages-subscriptions admin">
    <div class="a-tab" id="accordion-tab">
      <div class="a-tab__control">
        <router-link to="categories" class="a-tab__btn" :class="{ 'collapsed': !showCategories }">{{$t('form.messages.settings.tabs.categories')}}</router-link>
        <router-link to="cost" class="a-tab__btn" :class="{ 'collapsed': !showCost }">{{$t('form.messages.settings.tabs.cost')}}</router-link>
      </div>
      <div class="a-tab__open">
        <categories-settings v-if="showCategories"></categories-settings>
        <cost-settings v-if="showCost"></cost-settings>
      </div>
    </div>
  </div>
</template>

<script>
  import CategoriesSettings from './CategoriesSettings'
  import CostSettings from './CostSettings'

  export default {
    components: {CostSettings, CategoriesSettings},

    mounted() {
      this.runBlockerAction(async () => {
        try {
          await this.$store.dispatch('getSubscriptionSettings');
        }
        catch(e) {
          console.error('unable to fetch subscriptions settings', e);
          this.globalErrorHandler(e);
        }
      })
    },

    computed: {
      showCategories() {
        return this.$route.params.tab === 'categories';
      },

      showCost() {
        return this.$route.params.tab === 'cost';
      }
    }
  }
</script>

<style scoped>
</style>
